import { isReservedSubdomain } from "./reserved.js";

/** Extract tenant slug from a hostname like `{slug}.{rootDomain}`. */
export function parseTenantSlugFromHost(
  hostname: string,
  rootDomain: string,
): string | null {
  const host = hostname.trim().toLowerCase().split(":")[0] ?? "";
  const root = rootDomain.trim().toLowerCase();
  if (!host || !root) return null;
  if (host === root || host === `www.${root}`) return null;

  const suffix = `.${root}`;
  if (!host.endsWith(suffix)) return null;

  const label = host.slice(0, -suffix.length);
  if (!label || label.includes(".")) return null;
  if (isReservedSubdomain(label)) return null;
  return label;
}
